import {AbstractControl, ValidatorFn} from '@angular/forms';

function isValidRegon(regon?: string): boolean {
  if (typeof regon !== 'string') {
    return false;
  }

  const longReg = /^[0-9]{14}$/;

  if (longReg.test(regon)) {
    return true;
  }

  const reg = /^[0-9]{9}$/;
  if (!reg.test(regon)) {
    return false;
  } else {
    const digits = ('' + regon).split('');
    let checksum = (8 * parseInt(digits[0], 10) + 9 * parseInt(digits[1], 10) + 2
      * parseInt(digits[2], 10) + 3 * parseInt(digits[3], 10) + 4
      * parseInt(digits[4], 10) + 5 * parseInt(digits[5], 10) + 6
      * parseInt(digits[6], 10) + 7 * parseInt(digits[7], 10)) % 11;
    if (checksum === 10) {
      checksum = 0;
    }

    return (parseInt(digits[8], 10) === checksum);
  }
}

export function validRegon(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null =>
    (!control.value || isValidRegon(control.value))
      ? null : {invalidRegon: true};
}
